"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var each_1 = require("./each");
exports.default = each_1.default;
//# sourceMappingURL=for-in.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/for-in.js
// module id = 1100
// module chunks = 37